<main class="page">
  <!-- Steps -->
  <div class="steps">
    @for (step of steps(); track step.number) {
      <button
        class="step"
        [class.active]="step.active"
        [class.completed]="step.completed"
        type="button"
        [disabled]="!isStepClickable(step)"
        (click)="goToStep(step)"
      >
        <span class="step-number">{{ step.number }}</span>
        <span class="step-label">{{ step.label }}</span>
      </button>
    }
  </div>

  <!-- Form -->
  <div class="form-container">
    <h1 class="form-title">Step {{ steps()[0].number }} · {{ steps()[0].label }}</h1>

    <form class="form">
      <!-- Row 1: Project Team & AFE Number -->
      <div class="form-row">
        <div class="form-group">
          <label class="form-label">
            Project Team
            <span class="required">*</span>
          </label>
          <input
            class="form-select"
            [ngModel]="formData().projectTeam"
            (ngModelChange)="onProjectTeamInput($event)"
            name="projectTeam"
            placeholder="— Select or type —"
            autocomplete="off"
            [matAutocomplete]="projectTeamOptions"
            #projectTeamTrigger="matAutocompleteTrigger"
            (focus)="openProjectTeamOptions(projectTeamTrigger)"
            (click)="openProjectTeamOptions(projectTeamTrigger)"
            (blur)="onProjectTeamBlur()"
            [readonly]="isSubmittedStatus()"
            [disabled]="isSubmittedStatus()"
          />
          <mat-autocomplete #projectTeamOptions="matAutocomplete">
            @for (team of filteredTeams(); track team) {
              <mat-option [value]="team">{{ team }}</mat-option>
            }
          </mat-autocomplete>
          @if (submitAttempted() && !formData().projectTeam) {
            <p class="field-error">Project Team is required.</p>
          }
        </div>

        <div class="form-group">
          <label class="form-label">
            AFE No.
            <span class="required">*</span>
            <mat-icon class="info-icon" matTooltip="Mandatory. Provide Cost Centre of AFE No. if not available.">
              info
            </mat-icon>
          </label>
          <input
            class="form-input"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            [ngModel]="formData().afeNumber"
            (ngModelChange)="onAfeNumberInput($event)"
            (keydown)="blockNonDigit($event)"
            name="afeNumber"
            placeholder="Enter AFE Number"
            minlength="10"
            maxlength="10"
            [readonly]="isSubmittedStatus()"
            [disabled]="isSubmittedStatus()"
          />
          @if (submitAttempted() && !formData().afeNumber.trim()) {
            <p class="field-error">AFE No. is required.</p>
          } @else if (submitAttempted() && formData().afeNumber.trim().length !== 10) {
            <p class="field-error">AFE No. must be exactly 10 digits.</p>
          } @else if (submitAttempted() && !/^[0-9]+$/.test(formData().afeNumber)) {
            <p class="field-error">AFE No. must contain only digits.</p>
          } @else {
            <p class="helper-text">Mandatory. Provide AFE No. for TW.</p>
          }
        </div>
      </div>

      <!-- Is this a new Project -->
      @if (!projectId()) {
        <div class="form-group">
          <label class="form-label">
            Is this a new Project?
            <span class="required">*</span>
          </label>
          <div class="radio-group">
            <label class="radio-label">
              <input
                type="radio"
                name="isNewProject"
                [value]="true"
                [ngModel]="formData().isNewProject"
                (ngModelChange)="formData.update(f => ({ ...f, isNewProject: $event }))"
                [disabled]="isSubmittedStatus()"
              />
              <span>Yes</span>
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="isNewProject"
                [value]="false"
                [ngModel]="formData().isNewProject"
                (ngModelChange)="formData.update(f => ({ ...f, isNewProject: $event }))"
                [disabled]="isSubmittedStatus()"
              />
              <span>No</span>
            </label>
          </div>
          <p class="helper-text">
            "Yes" opens a blank New Project form (Step 2a). "No" lets you search an existing project, then pre-fills its details (Step 2b).
          </p>
        </div>
      }
    </form>
  </div>

  <!-- Actions -->
  <div class="actions">
    <button class="btn btn-secondary" (click)="goBack()">
      ‹ Back
    </button>
    <div class="actions__right">
      @if (canSave()) {
        <button class="btn btn-outline" [disabled]="isSaving()" (click)="save()">
          {{ isSaving() ? 'Saving...' : 'Save' }}
        </button>
      }
      <button class="btn btn-primary" (click)="continue()">
        Continue ›
      </button>
    </div>
  </div>
</main>
